import type { JSX } from 'react';
import React from 'react';

import type { Campaign, ICampaignAttributes } from '@feathr/blackbox';

import { getCampaignIcon } from '../CampaignIcons';
import SelectOption from './SelectOption';
import type { ISelectOptionProps, ISelectSingleValueProps } from './SelectOptions.types';
import SelectSingleValue from './SelectSingleValue';

import * as styles from './SelectOptions.css';

export function CampaignIconOption<T extends ICampaignAttributes>(
  props: Readonly<ISelectOptionProps<T>>,
): JSX.Element {
  return (
    <SelectOption {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>
          {getCampaignIcon((props.data as ICampaignAttributes)._cls)}
        </div>
        <div className={styles.contentWrapper}>
          <span>{props.data.name}</span>
        </div>
      </div>
    </SelectOption>
  );
}

export function CampaignModelIconOption<T extends Campaign>(
  props: Readonly<ISelectOptionProps<T>>,
): JSX.Element {
  const campaign = props.data.toJS();
  return (
    <SelectOption {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>{getCampaignIcon(campaign._cls)}</div>
        <div className={styles.contentWrapper}>
          <span>{campaign.name}</span>
        </div>
      </div>
    </SelectOption>
  );
}

export function CampaignSingleValue<T extends Campaign>(
  props: Readonly<ISelectSingleValueProps<T>>,
): JSX.Element {
  const campaign = props.data.toJS();

  return (
    <SelectSingleValue {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>{getCampaignIcon(campaign._cls)}</div>
        <div className={styles.contentWrapper}>
          <span>{campaign.name}</span>
        </div>
      </div>
    </SelectSingleValue>
  );
}
